import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { ICandidate } from './interfaces';
import { IProgress } from 'projects/labcorp/clinical-trials-ui/src/lib/interfaces';

export function buildProgressForm(candidate: ICandidate): FormArray {
  return new FormArray(candidate.researchSubject?.progress?.map(obj => initProgressForm(obj)) || []);
}

export function initProgressForm(progress: IProgress): FormGroup {
  return new FormGroup({
    type: new FormGroup({
      coding: new FormArray(progress.type?.coding?.map(coding => initCodingForm(coding.code)) || [])
    }),
    subjectState: new FormGroup({
      coding: new FormArray(progress.subjectState?.coding?.map(coding => initCodingForm(coding.code)) || [])
    }),
    startDate: new FormControl(progress?.startDate),
    endDate: new FormControl(progress?.endDate),
  });
}

export function initCodingForm(code: string): FormGroup {
  return new FormGroup({
    code: new FormControl(code, [Validators.required]),
  });
}

export function updateCandidateStatus(progressFormArray: FormArray, status: string): void {
  const currentProgressControl = progressFormArray.controls[progressFormArray.length - 1];
  const currentDateISO = (new Date()).toISOString();

  if (progressFormArray.dirty) {
    const codingControl = (currentProgressControl.get('subjectState.coding') as FormArray).controls[0];
    codingControl.get('code').patchValue(status);
    currentProgressControl.get('startDate').patchValue(currentDateISO);
  }
  else {
    currentProgressControl?.get('endDate').patchValue(currentDateISO);

    const newProgress: IProgress = {
      type: {
        coding: [
          {
            code: 'active'
          }
        ]
      },
      subjectState: {
        coding: [
          {
            code: status
          }
        ]
      },
      startDate: currentDateISO,
    };

    progressFormArray.push(initProgressForm(newProgress));
  }
}
